import { Game } from "../../../Game";
import { AtlasUtils } from "../../../Utils/Atlas/AtlasUtils";
import { eSlideMessageState, SlideMessageBase, SlideMessageSettings } from "../../../Utils/SlideMessage";
import { TIMER } from "../../Gameplay";
import { IAnimMessage } from "./AnimMessageBase";



export class AnimMessage2 extends SlideMessageBase implements IAnimMessage {
    private static readonly SCALE = 1;
    private static _stateProcessFncs: ((progress: number) => void)[];

    private _msgEnt: pc.Entity;
    private _msgSlideDis: number;
    private _frameRect = new pc.Vec4();
    private _posY: number;

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        super(new SlideMessageSettings(750, 750, 500), TIMER);

        if (!AnimMessage2._stateProcessFncs) {
            AnimMessage2._stateProcessFncs = [
                this.processSlideIn,
                this.processSlideOutDelay,
                this.processSlideOut
            ];
        }

        this._msgEnt = new pc.Entity();
        this._msgEnt.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0.5, 1, 0.5, 1],
            pivot: [0.5, 0.5],
        });
        this._msgEnt.enabled = false;
        screen.addChild(this._msgEnt);
    }


    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    reset(): void {
        super.reset();
        this._msgEnt.enabled = false;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    play(atlas: pc.TextureAtlas, frameKey: string, y: number): void {
        let element = this._msgEnt.element;
        let frameRect = (atlas.frames[frameKey] as pc.TextureAtlasFrame).rect;

        element.texture = atlas.texture;
        element.rect = AtlasUtils.getAtlasFrameRegion(atlas, frameKey, this._frameRect);
        element.opacity = 1;
        element.width = Math.round(Math.min(frameRect.z * AnimMessage2.SCALE, Game.scale.width * 0.8));
        element.height = Math.round(frameRect.w * (element.width / frameRect.z));

        this._msgEnt.enabled = true;
        this._msgSlideDis = (Game.scale.width + this._msgEnt.element.width) / 2;

        this._posY = y;
        super.showMessage();
    }


    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    protected updateContainer(state: eSlideMessageState, stateProgress: number): void {
        AnimMessage2._stateProcessFncs[state].call(this, stateProgress);
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    private processSlideIn(progress: number): void {
        progress = pc.CubicOut(progress);

        // Pozice
        this.updatePos(this._msgSlideDis * (1 - progress));

        // Opacity
        this._msgEnt.element.opacity = progress;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    private processSlideOutDelay(progress: number): void {
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    private processSlideOut(progress: number): void {
        progress = pc.CubicIn(progress);

        // Pozice
        this.updatePos(-this._msgSlideDis * progress);

        // Opacity
        this._msgEnt.element.opacity = 1 - progress;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    private updatePos(x: number): void {
        this._msgEnt.setLocalPosition(x, -Game.scale.minHeight * this._posY, 0);
    }
}